import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";

/**
 * useRecaptchaToken
 * Returns a stable async function that requests a fresh reCAPTCHA v3 token
 * for the given action. Falls back to null if reCAPTCHA hasn't loaded yet
 * (e.g. when REACT_APP_RECAPTCHA_SITE_KEY is missing in dev).
 *
 * Usage:
 *   const getRecaptchaToken = useRecaptchaToken();
 *   const token = await getRecaptchaToken("login");
 */
export const useRecaptchaToken = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return useCallback(
    async (action) => {
      if (!executeRecaptcha) return null;
      try {
        return await executeRecaptcha(action || "submit");
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("[recaptcha] execute failed", err);
        return null;
      }
    },
    [executeRecaptcha]
  );
};

export const RECAPTCHA_ACTIONS = Object.freeze({
  CONTACT: "contact",
  TENANT_REGISTER: "tenant_register",
  DOCTOR_LOGIN: "doctor_login",
  TENANT_LOGIN: "tenant_login",
  PASSWORD_RESET: "password_reset",
});
